
export default function Hero() {
  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.95) 50%, rgba(255, 255, 255, 0.7) 100%), url('https://public.readdy.ai/ai/img_res/38878143ab21c564ec9f624344b1565f.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-20 w-full">
        <div className="max-w-2xl">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Secure Your Digital Life with Our VPN
          </h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Experience ultimate online privacy and security with VELETRGOVINA TT's advanced VPN solution. Browse anonymously, protect your data, and access content freely from anywhere in the world.
          </p>
          <div className="flex flex-wrap gap-4">
            <button className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg">
              Get Started
            </button>
            <button className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold border-2 border-blue-600 hover:bg-blue-50 transition-colors cursor-pointer whitespace-nowrap">
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
